import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "lifecycle-event-reference"
    }}>{`Lifecycle event reference`}</h1>
    <h2 {...{
      "id": "events-handled-by-lifecycle"
    }}>{`Events handled by Lifecycle`}</h2>
    <p>{`The following event is handled by the Lifecycle extension:`}</p>
    <h3 {...{
      "id": "lifecycle-content-request"
    }}>{`Lifecycle content request`}</h3>
    <p>{`This event represents a request to the Lifecycle extension to start or pause collecting data and is generated when the `}<inlineCode parentName="p">{`lifecycleStart`}</inlineCode>{` and `}<inlineCode parentName="p">{`lifecyclePause`}</inlineCode>{` APIs are used.`}</p>
    <h4 {...{
      "id": "event-details"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Source`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Paired`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Direction`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventType.lifecycle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventSource.requestContent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition"
    }}>{`Data payload definition`}</h4>
    <p>{`The following key/value pair is used in the events:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`action`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Represents the lifecycle action type and can be one of these values: `}<inlineCode parentName="td">{`start`}</inlineCode>{`/`}<inlineCode parentName="td">{`pause`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`additionalcontextdata`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map that contains the user-supplied context data.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "sample-events"
    }}>{`Sample events`}</h3>
    <p>{`The following section displays sample lifecycle content requests.`}</p>
    <h4 {...{
      "id": "start-lifecycle-request"
    }}>{`Start Lifecycle request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{    
    "action": "start",    
    "additionalcontextdata": {        
        "key1" : "value1",        
        "key2" : "value2"    
    }
}
`}</code></pre>
    <h3 {...{
      "id": "pause-lifecycle-request"
    }}>{`Pause Lifecycle request`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{    
    "action": "pause"
}
`}</code></pre>
    <h3 {...{
      "id": "hub-shared-state"
    }}>{`Hub shared state`}</h3>
    <p>{`Lifecycle listens for the Configuration shared state events.`}</p>
    <h2 {...{
      "id": "events-dispatched-by-lifecycle"
    }}>{`Events dispatched by Lifecycle`}</h2>
    <p>{`The following events are dispatched by the Lifecycle extension:`}</p>
    <h3 {...{
      "id": "lifecycle-data-content-response"
    }}>{`Lifecycle data content response`}</h3>
    <p>{`This event is a response from the Lifecycle module to notify lifecycle context data in which a client/module might be interested. If a callback has been registered, this event can be used to issue a callback to the user.`}</p>
    <p>{`The event is generated by the Lifecycle extension, when the `}<inlineCode parentName="p">{`lifecycleStart`}</inlineCode>{` API is called when a new session is started and it contains the lifecycle data as part of `}<inlineCode parentName="p">{`lifecyclecontextdata`}</inlineCode>{` and previous session information. For more information about the available data, see `}<a parentName="p" {...{
        "href": "./metrics.md"
      }}>{`Lifecycle Data`}</a>{`​.`}</p>
    <h4 {...{
      "id": "event-details-1"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Source`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Paired`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Direction`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.lifecycle`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.responseContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-1"
    }}>{`Data payload definition`}</h4>
    <p>{`Here are the key-value pairs in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Required`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`lifecyclecontextdata`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Map`}{`<`}{`String,String`}{`>`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The value is a map of the key-value pairs that are generated by Lifecycle. This data can be consumed by other modules that operate on the data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sessionevent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The type of event which triggered a `}<inlineCode parentName="td">{`start`}</inlineCode>{` response.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`starttimestampmillis`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Long`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The start timestamp of the new session.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`maxsessionlength`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Long`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Maximum time in milliseconds before a session times out. The value is currently set to 7 days. This key is different from the configuration parameter, `}<inlineCode parentName="td">{`lifecycle.sessionTimeout`}</inlineCode>{`, which specifies the timeout for a `}<strong parentName="td">{`paused`}</strong>{` session.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`previoussessionstarttimestampmillis`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Long`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The previous session's start timestamp. If there was no previous session, the value could be `}<inlineCode parentName="td">{`0L`}</inlineCode>{` .`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`previoussessionpausetimestampmillis`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Long`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The previous session's pause timestamp. If there was no previous session, the value could be `}<inlineCode parentName="td">{`0L`}</inlineCode>{` .`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "lifecycle-application-foreground"
    }}>{`Lifecycle application foreground`}</h3>
    <p>{`This event is a response from the Lifecycle extension to notify that the application is being displayed in the foreground. The event is generated by the Lifecycle extension when the `}<a parentName="p" {...{
        "href": "./api-reference.md#lifecyclestart"
      }}>{`lifecycleStart`}</a>{` API is called, typically when the application comes to the foreground of the device.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`To forward this event to the Adobe Experience Platform Edge Network, follow the steps outlined in `}<a parentName="p" {...{
        "href": "../../../../edge/lifecycle-for-edge-network/index.md#configure-a-rule-to-forward-lifecycle-data-to-platform"
      }}>{`Configure a Rule to forward Lifecycle data to Platform`}</a>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`In Android, there is a 500 millisecond timeout between consecutive `}<inlineCode parentName="p">{`lifecycleStart`}</inlineCode>{` and `}<inlineCode parentName="p">{`lifecyclePause`}</inlineCode>{` events to prevent dispatching of events due to switching between Android activities.`}</p>
    <h4 {...{
      "id": "event-details-2"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventType.lifecycle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventSource.applicationLaunch`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload"
    }}>{`Data payload`}</h4>
    <p>{`The Lifecycle application foreground data payload is defined by the Platform Mobile Lifecycle Details XDM field group, and includes information about the application, device, and environment when the event occurred. Please refer to `}<a parentName="p" {...{
        "href": "../../../../edge/lifecycle-for-edge-network/metrics.md#lifecycle-application-foreground-data"
      }}>{`Lifecycle Application Foreground data`}</a>{` for a list of data included with this event.`}</p>
    <h3 {...{
      "id": "lifecycle-application-background"
    }}>{`Lifecycle application background`}</h3>
    <p>{`This event is a response from the Lifecycle extension to notify that the application is in the background.`}</p>
    <p>{`The event is generated by the Lifecycle extension when:`}</p>
    <ul>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`lifecyclePause`}</inlineCode>{` API is called, typically when the application goes to the background of the device.`}</li>
      <li parentName="ul">{`The `}<inlineCode parentName="li">{`lifecycleStart`}</inlineCode>{` API is called without a previous call to `}<inlineCode parentName="li">{`lifecyclePause`}</inlineCode>{` (such as when the application terminates unexpectedly). In this case, a Lifecycle Application Background event is dispatched just before the Lifecycle Application Foreground event, however the background event's timestamp is backdated to a time before the application previously went in the background.`}</li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`To forward this event to the Adobe Experience Platform Edge Network, follow the steps outlined in `}<a parentName="p" {...{
        "href": "../../../../edge/lifecycle-for-edge-network/index.md#configure-a-rule-to-forward-lifecycle-data-to-platform"
      }}>{`Configure a Rule to forward Lifecycle data to Platform`}</a>{`.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`In Android, there is a 500 millisecond timeout between consecutive `}<inlineCode parentName="p">{`lifecycleStart`}</inlineCode>{` and `}<inlineCode parentName="p">{`lifecyclePause`}</inlineCode>{` events to prevent dispatching of events due to switching between Android activities.`}</p>
    <h4 {...{
      "id": "event-details-3"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Event Source`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventType.lifecycle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`com.adobe.eventSource.applicationClose`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-1"
    }}>{`Data payload`}</h4>
    <p>{`The Lifecycle Application Background data payload is defined by the Platform Mobile Lifecycle Details XDM field group, and includes information about the application close type and previous session length. Please refer to `}<a parentName="p" {...{
        "href": "../../../../edge/lifecycle-for-edge-network/metrics.md#lifecycle-application-background-data"
      }}>{`Lifecycle Application Background data`}</a>{` for a list of data included with this event.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      